<template>
  <div class="list-results">
    <template v-if="contentType === 'Courses'">
      <div
        v-for="item in items"
        :key="item.objectID"
        class="list-results__item"
      >
        <ListResult
          :type="contentType"
          :course="item"
          :progress="getCourseProgress(item)"
          :gradient="$getGradient()"
          :tileImg="$getCourseBackground(item.objectID, 'xxs')"
          :duration="
            item.duration && item.duration.length
              ? $duration.getCourseDuration(item)
              : '0:00'
          "
          :link="$buildContentLink('course', item)"
          :difficulty="item.difficulty || ''"
          :isFreeTrialUser="isFreeTrialUser"
          :learningAreaColor="getLearningAreaColor(item)"
          :learningArea="getLearningArea(item)"
          @el-rend="handleRememberPosition"
          :showAddedDate="true"
        />
      </div>
    </template>
    <template v-if="contentType === 'Learning Paths'">
      <div
        v-for="item in items"
        :key="item.objectID"
        class="list-results__item"
      >
        <ListResult
          :type="contentType"
          :course="item"
          :gradient="$getGradient()"
          :tileImg="$getPlaylistBackground(item.objectID)"
          :link="$buildContentLink('path', item)"
          :duration="
            item.duration && item.duration.length
              ? $duration.getCourseDuration(item)
              : '0:00'
          "
          :difficulty="item.difficulty || ''"
          :learningAreaColor="getLearningAreaColor(item)"
          :learningArea="getLearningArea(item)"
          @el-rend="handleRememberPosition"
          :showAddedDate="true"
        />
      </div>
    </template>
    <template v-if="contentType === 'Videos'">
      <VideoListResults
        :items="items"
        :parentsSearchResults="parentsSearchResults"
        @open-video="$emit('open-video', $event)"
      />
    </template>
    <template v-if="contentType === 'Bootcamps'">
      <BootcampListResults
        :items="items"
        @element-render="handleRememberPosition"
      />
    </template>
    <template v-if="contentType === 'Labs'">
      <LabListResults
        :items="items"
        :parentsSearchResults="parentsSearchResults"
        @open-video="$emit('open-video', $event)"
        @element-rend="handleRememberPosition"
      />
    </template>
  </div>
</template>

<script>
import ListResult from '@/components/search/ListResult.vue'
import BootcampListResults from '@/components/search/BootcampListResults.vue'
import VideoListResults from '@/components/search/VideoListResults.vue'
import { getLearningAreaColor, getLearningArea } from '@/helpers'
import LabListResults from '@/components/search/LabListResults.vue'

export default {
  name: 'ListResults',
  components: {
    ListResult,
    VideoListResults,
    BootcampListResults,
    LabListResults,
  },
  data: () => {
    return {
      getLearningAreaColor,
      getLearningArea,
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
    parentsSearchResults: {
      type: Object,
      required: false,
      defaul: {},
    },
    activeCourses: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
  },
  methods: {
    openVideo(video) {
      this.$emit('open-video', video)
    },
    getCourseProgress(course) {
      let progress
      progress = course?.user_status?.progress ?? course?.progress ?? 0
      if (progress) {
        return progress
      }
      const findFunc = activeCourse => {
        return activeCourse.id === course.objectID
      }
      if (this.activeCourses.length) {
        const ac = this.activeCourses.find(findFunc)
        if (ac) {
          progress = Math.floor(ac.user_status.progress * 100)
        }
      }
      return progress > 0 ? progress : 0
    },
    handleRememberPosition(elId) {
      this.$emit('element-rendered', elId)
    },
  },
}
</script>

<style lang="scss" scoped>
.list-results {
  display: flex;
  flex-wrap: wrap;
  &__item {
    min-width: 100%;
    height: 134px;
    padding: 0;
    margin-bottom: 10px;
    @include mobile {
      height: 92px;
    }
  }
}
</style>
